import { createContext } from 'react';

/** Only the Arty flyout sets `card`: there every chat image is the Arty image card; /chat keeps the legacy box. */
export const ArtyRenderContext = createContext({ card: false });
